import { ButtonLink } from "@/components/shared/Button/Button";
import { SanityFileSource } from "@sanity/asset-utils";
import { getFile } from "../../../utilities/image-helpers";
import styles from "./RichTextDownload.module.scss";

interface RichTextDownloadProps {
	file?: SanityFileSource | null;
	label?: string | null;
}

export const RichTextDownload = ({ file, label }: RichTextDownloadProps) => {
	return (
		file && (
			<p className={styles["download"]}>
				<ButtonLink
					icon="download"
					href={getFile(file)?.url}
					label={label || "Download"}
					target="_blank"
				/>
			</p>
		)
	);
};
